import { useCallback } from 'react';

import { useReactiveForm as useReactiveFormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/hooks';
import {
	UseReactiveFormInput,
	UseReactiveFormInputPropsOutput,
	UseReactiveFormOutput as UseReactiveFormOutputShared,
} from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/types';

type UseReactiveFormInputPropsOutputShared = Pick<
	UseReactiveFormInputPropsOutput,
	'name' | 'value' | 'onChange' | 'onFocus' | 'onBlur'
>;

export type UseReactiveFormCFPInputPropsOutput = UseReactiveFormInputPropsOutputShared & {
	error?: boolean;
	errorMessage?: string;
};

export interface UseReactiveFormOutput extends UseReactiveFormOutputShared {
	getCFPInputProps: (name: string) => UseReactiveFormCFPInputPropsOutput;
}

export const useReactiveForm = (props: UseReactiveFormInput): UseReactiveFormOutput => {
	const reactiveForm = useReactiveFormShared(props);

	const getCFPInputProps = useCallback(
		(name: string): UseReactiveFormCFPInputPropsOutput => {
			const reactiveFormGetInputProps = reactiveForm.getInputProps(name);
			const { showErrors, error, onChange } = reactiveFormGetInputProps;

			return {
				...reactiveFormGetInputProps,
				error: Boolean(showErrors && error),
				errorMessage: showErrors && error ? error : undefined,
				onChange: (value: string) => onChange(value),
			};
		},
		[reactiveForm]
	);

	return {
		...reactiveForm,
		getCFPInputProps,
	};
};
